var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconIosMail = function SvgIconIosMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.675,
    height: 14.313,
    viewBox: "0 0 20.675 14.313",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.375 -7.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.881,10.344l-5.348,5.447a.1.1,0,0,0,0,.139l3.742,3.986a.645.645,0,0,1,0,.914.648.648,0,0,1-.914,0L17.634,16.86a.1.1,0,0,0-.144,0l-.91.924a4,4,0,0,1-2.853,1.2,4.082,4.082,0,0,1-2.912-1.238l-.875-.89a.1.1,0,0,0-.144,0L6.069,20.831a.648.648,0,0,1-.914,0,.645.645,0,0,1,0-.914L8.9,15.931a.106.106,0,0,0,0-.139L3.544,10.344a.1.1,0,0,0-.169.07v10.9a1.6,1.6,0,0,0,1.59,1.59H22.46a1.6,1.6,0,0,0,1.59-1.59v-10.9A.1.1,0,0,0,23.881,10.344Z",
    transform: "translate(0 -0.715)",
    fill: "#f6c866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.962,16.975a2.7,2.7,0,0,0,1.943-.815l7.8-7.937a1.562,1.562,0,0,0-.984-.348H5.21a1.552,1.552,0,0,0-.984.348l7.8,7.937A2.7,2.7,0,0,0,13.962,16.975Z",
    transform: "translate(-0.249)",
    fill: "#f6c866"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconIosMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-ios-mail.e1216847.svg";
export { ForwardRef as ReactComponent };